import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import heavyMachineryDeleteAction from './heavyMachineryDelete.action.json' with { type: 'json' }

const heavyMachineryDeleteDefinition = defineAction({
  ...heavyMachineryDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default heavyMachineryDeleteDefinition
